import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/uiconfig';
import { withRouter, useLocation } from 'react-router-dom';

import { withAuthenticationContext, useAuthentication, AUTH_ERRORS } from 'gw-digital-auth-react';
import { useTranslator, IntlContext } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import styles from './RIChangePassword.module.scss';
import metadata from './RIChangePassword.metadata.json5';
import messages from './RIChangePassword.messages';

function RIChangePassword(props) {
    const translator = useTranslator();
    // const viewModelService = useContext(ViewModelServiceContext);
    // const localeService = ServiceManager.getService('locale-service');
    const location = useLocation();
    const intl = useContext(IntlContext);
    const auth = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const [formData, updateFormData] = useState('');
    const [userId, updateUserId] = useState();
    const [pageError, updatePageError] = useState();
    const [pageView, setPageView] = useState();
    const {
        changePasswordExt, authHeader
    } = useAuthentication();

    // Handle press Enter key to trigger the Change Password button. ----------
    // VP 3-2023 - Comment code userEffect() during upgrade
    // useEffect(() => {
    //     document.querySelector('#confirmPassword').addEventListener(
    //         'keypress',
    //         (e) => {
    //             if (e.key === 'Enter') {
    //                 document.querySelector('#changePassword').click();
    //             }
    //         }
    //     );
    // }, []);
    // ---------------------------------------------------------------

    const changeMessage = useCallback(() => {
        let title = auth.name; // oob
        const msg = translator(messages.changeMessage);
        if (!_.isUndefined(auth.authUserData)) {
            title = `${msg}: ${auth.authUserData.firstName} ${auth.authUserData.lastName} (${auth.authUserData.userID})`;
        }
        return title;
    }, [auth, userId]);

    const isEmpty = (value) => {
        return _.isNil(value) || _.isEmpty(value);
    };

    const checkRIPasswordValidity = (password) => {
        const RI_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*().?;:])/;
        if (!isEmpty(password) && (password.trim()).length >= 8) {
            return RI_PASSWORD_REGEX.test(password);
        }
        return false;
    };

    const handleNewPassword = useCallback(

        (evt) => {
            if (evt) {
                evt.preventDefault();
            }

            if (isEmpty(formData.newPassword) || isEmpty(formData.confirmPassword)) {
                updatePageError(AUTH_ERRORS.fieldEmpty);
                return Promise.resolve();
            }

            if (!checkRIPasswordValidity(formData.newPassword)) {
                updatePageError('invalidPasswordCriteria');
                return Promise.resolve();
            }

            if (!_.isEqual(formData.newPassword, formData.confirmPassword)) {
                updatePageError(AUTH_ERRORS.fieldIncorrect);
                return Promise.resolve();
            }

            if (_.isEqual(formData.newPassword, formData.currentPassword)) {
                updatePageError('invalidNewPassword');
                return Promise.resolve();
            }

            const newPasswordObject = {
                userID: auth.authUserData.userID,
                current_password: formData.currentPassword,
                new_password: formData.newPassword
            };
            return changePasswordExt(newPasswordObject, authHeader)
                .then(() => {
                    setPageView('success');
                })
                .catch((err) => {
                    switch (err.error) {
                        case AUTH_ERRORS.invalidTokenOrEmail:
                            updatePageError(AUTH_ERRORS.invalidTokenOrEmail);
                            break;
                        default:
                            updatePageError(AUTH_ERRORS.invalidAttempt);
                            break;
                    }
                });
        },
        [authHeader, changePasswordExt, formData]
    );

    const readValue = useCallback((id, path) => _.get(formData, path), [formData]);

    const writeValue = useCallback(
        (value, path) => updateFormData({
            ...formData,
            [path]: value
        }),
        [formData]
    );
    const passwordTip = () => {
        return <div><span className={styles.strong}>Password Tips </span>
                    To help keep your account safe, make sure your password:
               </div>;
    };
    const getLiValue0 = () => {
        return <div>Is at least 8 characters long</div>;
    };
    const getLiValue1 = () => {
        return <div>
                    Includes at least one letter, one number and one symbol (like !@#$%^&*().?;:)
               </div>;
    };
    const getLiValue2 = () => {
        return <div>Contains both uppercase and lowercase letters</div>;
    };

    const overrides = {
        '@field': {
            onValueChange: writeValue
        },
        errorMsg: {
            visible: !_.isUndefined(pageError),
            content: translator(messages[pageError])
        },
        tabadminTitleText: {
            content: changeMessage()
        },
        newPasswordFieldsContainer: {
            visible: !pageView
        },
        emailFieldContainer: {
            visible: !pageView
        },
        passwordForm: {
            onSubmit: handleNewPassword
        },
        changePassword: {
            onTrigger: handleNewPassword
        },
        actionsWrapperSingleButton: {
        // className: classNames(styles.actionsWrapperSingleButton, styles.coupleButtonStyle)
        },
        invalidTokenError: {
            visible: pageView === AUTH_ERRORS.invalidToken
        },
        invalidTokenOrPasswordError: {
            visible: pageView === AUTH_ERRORS.invalidTokenOrEmail
        },
        invalidAttemptError: {
            visible: pageView === AUTH_ERRORS.invalidAttempt
        },
        successfulContainer: {
            visible: pageView === 'success'
        },
        li0: {
            content: getLiValue0(),
        },
        li1: {
            content: getLiValue1(),
        },
        li2: {
            content: getLiValue2(),
        },
        passwordTip:{
            content: passwordTip()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveComponentMap: {
        // authmessagecomponent: AuthMessageComponent
        }
    };
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
//    return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
}

export default withRouter(RIChangePassword);
